import {Vue} from 'division-marker';
import App from './App.vue';
import router from './router';
import store from './store';
import {SaitenExtender} from 'division-marker';
import KwiSaitenExtender from './shared/KwiSaitenExtender';
import 'babel-polyfill';

Vue.config.productionTip = false;
SaitenExtender.Extender = new KwiSaitenExtender();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
